import React from "react";
import Repository from "./api/Repository";
import Store from "./Store";
import { hideLoading, showLoading } from "react-redux-loading-bar";
import { useSnackbar } from "notistack";
import * as Sentry from "@sentry/browser";

export default function AppIntercepter() {
  const { enqueueSnackbar } = useSnackbar();

  Repository.interceptors.request.use((config: any) => {
    Store.dispatch(showLoading());
    return config;
  });

  Repository.interceptors.response.use(
    (response) => {
      Store.dispatch(hideLoading());
      if (response?.data?.hasError) {
        enqueueSnackbar(response.data?.errorText ?? "There was an error", {
          variant: "error",
        });
        Sentry.captureMessage(response.data?.errorText);
      }
      return response;
    },
    (error) => {
      Store.dispatch(hideLoading());
      if (401 === error.response?.status) {
        Sentry.captureMessage(`401: ${error?.config?.url}`);
        window.location.href = "/";
      } else if (403 === error.response?.status) {
        Sentry.captureMessage(`403: ${error?.config?.url}`);
        enqueueSnackbar("You don't have permission to do that", {
          variant: "error",
        });
      } else {
        enqueueSnackbar("There was an error", {
          variant: "error",
        });
      }
    }
  );
  return <></>;
}
